import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaOperadoraIngreso', NominaOperadoraIngreso)

function NominaOperadoraIngreso($http) {
  this.get = _get

  function _get(id_proyecto, id_nomina, parcial) {
    return $http.get('/api/nominas/nomina/operadora/ingreso', {
      params: {id_proyecto: id_proyecto, id_nomina: id_nomina, parcial: parcial},
      schema: NominaOperadoraIngresoSchema,
    })
  }

  let NominaOperadoraIngresoSchema = {
    suministro: 'number',
    carga_social: 'number',
    impuesto_estatal: 'number',
    comision: 'number',
    subtotal: 'number',
    iva: 'number',
    total: 'number',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Operadora/Ingreso.js